import React, { useEffect, useState } from "react";
import "../../../incidents/cases/addCaseList.scss";
import FilterListIcon from "@mui/icons-material/FilterList";
import ViewcCasetable from "../../../../library/custom/gridTable/GridTable";
import SearchIcon from "@mui/icons-material/Search";
import Buttons from "../../../../library/custom/button/Button";
import SettingTable from "../../../incidents/incidentList/SettingTable";
import { useNavigate, useLocation } from "react-router-dom";
import UserFilterList from "../../shared/UserFilterList ";
import { TableLoader } from "../../../../library/common/Loader";
import {
  ORG_ID,
  PAGE_SIZE,
  ROW_PER_PAGE_SIZE,
} from "../../../../constant/constant";
import {
  ADD_ADMIN_NONPRIVILEGE_USER,
  ADMIN_SAFETY_LOG,
} from "../../../../constant/routeContant";
import { getPreviousRoute } from "../../../../utils/routeTracker";
import DialogBox from "../../../../library/common/DialogBox";
import NORow from "../../../../library/custom/noRow/noRow";
import ReportRowManipulte from "../../../incidents/incidentList/ReportRowManipulte";
import { checkPrivileges } from "../../../../utils/rolesHelper";
import { encodeSearchText, InactiveClient } from "../../../../utils/helper";
import downloadIcon from "../../../../assets/downloadIcon.svg";

export default function NonPrivilegeUserList({
  NavigateSingleUserMethode,
  loading,
  jobTitles,
  deleteNonPrivilegeLists,
  isDivision = true,
  divisiondata,
  NonPrivilegeuserListData,
  getNonPrivilegeLists,
  nonPrivilegeuserListDatas,
  deleteNonPrivilegeUserListData,
}) {
  const navigate = useNavigate();
  const location = useLocation();
  
  // Lazy state initialization: check if we should preserve state
  const [search, setSearch] = useState(() => {
    const previousRoute = getPreviousRoute();
    const shouldPreserve =
      previousRoute &&
      (previousRoute.startsWith(ADD_ADMIN_NONPRIVILEGE_USER) || previousRoute.startsWith(ADMIN_SAFETY_LOG)) &&
      sessionStorage.getItem("nonPrivilegeUserListPreserveState") === "true";
    
    if (shouldPreserve) {
      const savedSearch = sessionStorage.getItem("nonPrivilegeUserListSearch");
      return savedSearch ? decodeURIComponent(savedSearch) : "";
    }
    return "";
  });
  
  const [jobTitle, setjobTitle] = useState(() => {
    const previousRoute = getPreviousRoute();
    const shouldPreserve =
      previousRoute &&
      (previousRoute.startsWith(ADD_ADMIN_NONPRIVILEGE_USER) || previousRoute.startsWith(ADMIN_SAFETY_LOG)) &&
      sessionStorage.getItem("nonPrivilegeUserListPreserveState") === "true";
    
    if (shouldPreserve) {
      const savedJobTitle = sessionStorage.getItem("nonPrivilegeUserListJobTitle");
      return savedJobTitle || "";
    }
    return "";
  });
  
  const [divisionfilter, setDivisionFilter] = useState(() => {
    const previousRoute = getPreviousRoute();
    const shouldPreserve =
      previousRoute &&
      (previousRoute.startsWith(ADD_ADMIN_NONPRIVILEGE_USER) || previousRoute.startsWith(ADMIN_SAFETY_LOG)) &&
      sessionStorage.getItem("nonPrivilegeUserListPreserveState") === "true";
    
    if (shouldPreserve) {
      const savedDivision = sessionStorage.getItem("nonPrivilegeUserListDivision");
      return savedDivision || "";
    }
    return "";
  });
  
  const [page, setPage] = useState(() => {
    const previousRoute = getPreviousRoute();
    const shouldPreserve =
      previousRoute &&
      (previousRoute.startsWith(ADD_ADMIN_NONPRIVILEGE_USER) || previousRoute.startsWith(ADMIN_SAFETY_LOG)) &&
      sessionStorage.getItem("nonPrivilegeUserListPreserveState") === "true";
    
    if (shouldPreserve) {
      const savedPage = sessionStorage.getItem("nonPrivilegeUserListPage");
      return savedPage ? parseInt(savedPage) : 0;
    }
    return 0;
  });
  
  const [pageSize, setPageSize] = useState(() => {
    const previousRoute = getPreviousRoute();
    const shouldPreserve =
      previousRoute &&
      (previousRoute.startsWith(ADD_ADMIN_NONPRIVILEGE_USER) || previousRoute.startsWith(ADMIN_SAFETY_LOG)) &&
      sessionStorage.getItem("nonPrivilegeUserListPreserveState") === "true";
    
    if (shouldPreserve) {
      const savedPageSize = sessionStorage.getItem("nonPrivilegeUserListPageSize");
      return savedPageSize ? parseInt(savedPageSize) : PAGE_SIZE;
    }
    return PAGE_SIZE;
  });
  
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorElAdd, setAnchorElAdd] = useState(null);
  const [userListApiData, setUserListApiData] = useState({
    organisationId: ORG_ID(),
    page: 1,
    pageSize: pageSize,
    search: "",
    orgId: ORG_ID(),
    titleId: jobTitle ? jobTitle : "",
    divisionId: divisionfilter ? divisionfilter : "",
    isSendMail: false,
  });
  const [isTableLoading, setisTableLoading] = useState(false);
  const hasLoadedInitialData = React.useRef(false);

  const deletehandle = () => {
    setOpenModal(false);
    deleteNonPrivilegeLists(selectedRow.userid);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    window.close();
  };
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;
  const openAdd = Boolean(anchorElAdd);
  const idAdd = openAdd ? "simple-popover" : undefined;

  // Initial data load on mount - only run once
  useEffect(() => {
    if (hasLoadedInitialData.current) return;
    hasLoadedInitialData.current = true;
    
    const data = {
      page: page + 1,
      pageSize: pageSize,
      search: search ? encodeSearchText(search) : "",
      orgId: ORG_ID(),
      titleId: jobTitle || "",
      divisionId: divisionfilter || "",
      isSendMail: false,
    };
    getNonPrivilegeLists(data);
    
    // Clear sessionStorage after initial load
    sessionStorage.removeItem("nonPrivilegeUserListPreserveState");
    sessionStorage.removeItem("nonPrivilegeUserListSearch");
    sessionStorage.removeItem("nonPrivilegeUserListJobTitle");
    sessionStorage.removeItem("nonPrivilegeUserListDivision");
    sessionStorage.removeItem("nonPrivilegeUserListPage");
    sessionStorage.removeItem("nonPrivilegeUserListPageSize");
  }, []);

  // Handle delete success - preserve state and reload data
  useEffect(() => {
    if (deleteNonPrivilegeUserListData?.status === "SUCCESS") {
      if (nonPrivilegeuserListDatas?.filterObj) {
        getNonPrivilegeLists(nonPrivilegeuserListDatas.filterObj);
      } else {
        const data = {
          page: page + 1,
          pageSize: pageSize,
          search: search ? encodeSearchText(search) : "",
          orgId: ORG_ID(),
          titleId: jobTitle || "",
          divisionId: divisionfilter || "",
          isSendMail: false,
        };
        getNonPrivilegeLists(data);
      }
    }
  }, [deleteNonPrivilegeUserListData]);

  const handleClickAdd = (event) => {
    if (InactiveClient()) return;
    NavigateSingleUserMethode();
  };

  const handleautoSearch = (event) => {
    setisTableLoading(true);
    setTimeout(() => {
      setisTableLoading(false);
    }, 1);
    setPage(0);
    let searchText = "";
    if (event.target.value) {
      searchText = event.target.value;
    }
    setSearch(searchText);
    const data = {
      page: 1,
      pageSize: pageSize,
      titleId: jobTitle ? jobTitle : "",
      divisionId: divisionfilter ? divisionfilter : "",
      search: searchText ? encodeSearchText(searchText) : "",
      isSendMail: false,
    };
    setUserListApiData({
      page: 1,
      pageSize: pageSize,
      titleId: jobTitle ? jobTitle : "",
      divisionId: divisionfilter ? divisionfilter : "",
      search: searchText ? encodeSearchText(searchText) : "",
      isSendMail: false,
    });
    getNonPrivilegeLists(data);
  };

  const handlePagignation = (newPage) => {
    setPage(newPage);
    const data = {
      ...userListApiData,
      page: newPage + 1,
      pageSize: pageSize,
      search: search ? encodeSearchText(search) : "",
      orgId: ORG_ID(),
      titleId: jobTitle ? jobTitle : "",
      divisionId: divisionfilter ? divisionfilter : "",
      isSendMail: false,
    };
    setUserListApiData({
      ...userListApiData,
      page: newPage + 1,
      pageSize: pageSize,
      search: search ? encodeSearchText(search) : "",
      titleId: jobTitle ? jobTitle : "",
      divisionId: divisionfilter ? divisionfilter : "",
      isSendMail: false,
    });
    getNonPrivilegeLists(data);
  };

  const handleViewOnClick = (rows) => {
    sessionStorage.setItem("nonPrivilegeUserListPreserveState", "true");
    sessionStorage.setItem("nonPrivilegeUserListSearch", search ? encodeSearchText(search) : "");
    sessionStorage.setItem("nonPrivilegeUserListJobTitle", jobTitle || "");
    sessionStorage.setItem("nonPrivilegeUserListDivision", divisionfilter || "");
    sessionStorage.setItem("nonPrivilegeUserListPage", page.toString());
    sessionStorage.setItem("nonPrivilegeUserListPageSize", pageSize.toString());
    navigate(ADMIN_SAFETY_LOG, {
      state: { userId: rows.row.userid, userSafetyLog: true },
    });
  };

  const handleOnclick = (rows) => {
    if (InactiveClient()) return;
    sessionStorage.setItem("nonPrivilegeUserListPreserveState", "true");
    sessionStorage.setItem("nonPrivilegeUserListSearch", search ? encodeSearchText(search) : "");
    sessionStorage.setItem("nonPrivilegeUserListJobTitle", jobTitle || "");
    sessionStorage.setItem("nonPrivilegeUserListDivision", divisionfilter || "");
    sessionStorage.setItem("nonPrivilegeUserListPage", page.toString());
    sessionStorage.setItem("nonPrivilegeUserListPageSize", pageSize.toString());
    navigate(ADD_ADMIN_NONPRIVILEGE_USER, {
      state: { userId: rows.row.userid, editMode: true },
    });
  };
  const [openModal, setOpenModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState("");
  const deleteIncidents = (rows) => {
    if (InactiveClient()) return;
    setOpenModal(true);
    setSelectedRow(rows);
  };

  const columns = [
    { field: "userid", headerName: "User ID", flex: 2 },
    {
      field: "fullName",
      headerName: "Name",
      flex: 3,
      valueGetter: (params) =>
        `${params.getValue(params.id, "firstname") || ""} ${
          params.getValue(params.id, "lastname") || ""
        }`,
    },
    { field: "jobTitlename", headerName: "Job Title", flex: 3 },
    isDivision && { field: "divisionname", headerName: "Division", flex: 3 },
    isDivision && {
      field: "",
      flex: 1,
      sortable: false,
      disableClickEventBubbling: true,
      renderCell: (rows) => {
        return isDivision ? (
          <ReportRowManipulte
            rows={rows}
            safetyLogOnClick={() => handleViewOnClick(rows)}
            editOnClick={() => handleOnclick(rows)}
            deleteOnClick={() => deleteIncidents(rows?.row)}
            edit={checkPrivileges([64, 65, 12])}
            editLabel="Edit User"
            safetyLog={checkPrivileges([64, 65, 66, 12])}
            safetyLogLabel="Safety Log"
            deleted={checkPrivileges([64, 12])}
            deleteLabel="Delete User"
          />
        ) : (
          ""
        );
      },
    },
  ];

  const jobtitleOnChanges = (e) => {
    setjobTitle(e.target.value);
  };

  const onRowClick = (e) => {
    console.log("ROW CLICK");
  };

  const handleSearch = (data) => {
    setAnchorEl(null);
    getNonPrivilegeLists(data);
  };
  const handleClear = () => {
    setisTableLoading(true);
    setTimeout(() => {
      setisTableLoading(false);
    }, 1);
    setPage(0);
    setPageSize(PAGE_SIZE);
    setjobTitle("");
    setDivisionFilter("");
    setSearch("");
    const data = {
      page: 1,
      pageSize: PAGE_SIZE,
      search: "",
      titleId: "",
      orgId: ORG_ID(),
      divisionId: "",
      isSendMail: false,
    };
    handleSearch(data);
  };
  const handleApply = () => {
    setisTableLoading(true);
    setTimeout(() => {
      setisTableLoading(false);
    }, 1);
    setPage(0);
    setUserListApiData({
      ...userListApiData,
      titleId: jobTitle ? jobTitle : "",
      divisionId: divisionfilter ? divisionfilter : "",
      isSendMail: false,
    });
    setAnchorEl(null);
    const data = {
      ...userListApiData,
      page: 1,
      pageSize: pageSize,
      search: search ? encodeSearchText(search) : "",
      orgId: ORG_ID(),
      titleId: jobTitle ? jobTitle : "",
      divisionId: divisionfilter ? divisionfilter : "",
      isSendMail: false,
    };
    getNonPrivilegeLists(data);
  };

  const handlePageSizeChange = (newPazeSize) => {
    setPageSize(newPazeSize);
    setPage(0);
    const data = {
      ...userListApiData,
      page: 1,
      pageSize: newPazeSize,
      search: search ? encodeSearchText(search) : "",
      orgId: ORG_ID(),
      titleId: jobTitle ? jobTitle : "",
      divisionId: divisionfilter ? divisionfilter : "",
      isSendMail: false,
    };
    getNonPrivilegeLists(data);
  };

  const divisionFilterOnChanges = (e) => {
    setDivisionFilter(e.target.value);
  };

  const sendEmail = () => {
    const data = {
      ...userListApiData,
      page: page + 1,
      pageSize: pageSize,
      search: search ? encodeSearchText(search) : "",
      orgId: ORG_ID(),
      titleId: jobTitle ? jobTitle : "",
      divisionId: divisionfilter ? divisionfilter : "",
      isSendMail: true,
    };
    getNonPrivilegeLists(data);
  };

  return (
    <>
      <section className="grid_main_sec">
        {isDivision && (
          <div className="grid_main_header two_grid">
            <div className="grid_heading_style">Non-Privileged Users List</div>
            {openModal && (
              <DialogBox
                open={openModal}
                rows={[]}
                header={"Confirm Deletion"}
                deletehandle={deletehandle}
                handleCloseModal={() => setOpenModal(false)}
                content={"Are you sure you want to delete this User?"}
                view
              />
            )}
            <div>
              <div className="filter_btn">
                {checkPrivileges([12, 64, 65]) && (
                  <Buttons
                    id="btnAddUsers"
                    aria-describedby={idAdd}
                    varientAddIconBlue={true}
                    label={"Add User"}
                    onClick={(e) => handleClickAdd(e)}
                  />
                )}
              </div>
            </div>
          </div>
        )}

        <div className="grid_main_body">
          <div className="div-filter-container">
            <div className="filter_of_caselist">
              <div className="searchcaseid">
                <label htmlFor="search">
                  <span>
                    <SearchIcon />
                  </span>
                  <div>
                    <input
                      id="search"
                      placeholder="Search"
                      type="text"
                      value={search}
                      className=""
                      onChange={handleautoSearch}
                      autoComplete="off"
                    />
                  </div>
                </label>
              </div>

              {isDivision && (
                <div className="filter_btn">
                  <button
                    aria-describedby={id}
                    variant="contained"
                    type="button"
                    name="btn"
                    onClick={(e) => handleClick(e)}
                  >
                    <FilterListIcon id="icn" /> Filters
                  </button>
                  <UserFilterList
                    secondLabel="Job Title"
                    firstLabel="Division"
                    id={id}
                    open={open}
                    anchorEl={anchorEl}
                    handleClose={handleClose}
                    handleSearch={handleSearch}
                    handleApply={handleApply}
                    secondLebelFilter={jobTitles}
                    resetBtn={true}
                    handleClear={handleClear}
                    secondLebelOnChanges={jobtitleOnChanges}
                    secondLebelValue={jobTitle}
                    firstLebelOnChanges={divisionFilterOnChanges}
                    firstLebelValue={divisionfilter}
                    firstLebelFilter={divisiondata}
                    isShow={true}
                  />
                </div>
              )}
            </div>
            <div className="div-download-email-right" onClick={sendEmail}>
              <span>
                <img
                  src={downloadIcon}
                  className="DownLoadLogo"
                  alt="DownLoad Logo"
                />
              </span>
              Download Data
            </div>
          </div>
          {isTableLoading ? (
            ""
          ) : (
            <div className="desc_box row_uniq">
              <div className="table_style_ui">
                <ViewcCasetable
                  getRowId={(r) => r.userid}
                  rows={NonPrivilegeuserListData?.userData || []}
                  rowCount={NonPrivilegeuserListData?.itemsCount}
                  onRowClick={onRowClick}
                  columns={columns}
                  loading={loading}
                  components={{
                    LoadingOverlay: TableLoader,
                    NoRowsOverlay: NORow,
                  }}
                  checkboxSelection={false}
                  page={page}
                  pagination
                  pageSize={pageSize}
                  rowsPerPageOptions={ROW_PER_PAGE_SIZE}
                  onPageSizeChange={handlePageSizeChange}
                  onPageChange={handlePagignation}
                  backIconButtonProps={{ disabled: false }}
                  disableSelectionOnClick
                />
              </div>
            </div>
          )}
        </div>
      </section>
    </>
  );
}
